import { PrelineColourVariant } from '@payaca/types/preline';

export function getConnectionApplicationStatusBadgeColour(
  status: string | undefined
): PrelineColourVariant {
  switch (status) {
    case 'pending':
      return 'yellow';
    case 'submitted':
      return 'blue';
    case 'complete':
      return 'green';
    case 'failed':
      return 'red';
    default:
      return 'gray';
  }
}
